import { Component, OnInit } from '@angular/core';
import { AutoLogoutService } from '../shared/service/auto-logout.service';
const LOCAL_USER_KEY = "UserName";
const STORE_KEY = 'lastAction';
@Component({
  selector: 'app-admin-contact',
  templateUrl: './admin-contact.component.html',
  styleUrls: ['./admin-contact.component.css']
})
export class AdminContactComponent implements OnInit {

  constructor(private autoLogoutService: AutoLogoutService) {
    localStorage.setItem(STORE_KEY, Date.now().toString());
    this.autoLogoutService.check();
    this.autoLogoutService.initListener();
    this.autoLogoutService.initInterval();
  }
  ngOnInit() {

  }

}
